module.exports = __webpack_public_path__ + "img/2_5.8db80bf6.png";